module.exports = __webpack_public_path__ + "static/media/designed-for-everyone.46e485b0.jpg";